{
  "pt": {
    "form": {
      "actions": {
        "cancel": "Cancelar",
        "clear": "Limpar",
        "closeFullPage": "Fechar página inteira",
        "copyText": "Clique para copiar o texto",
        "create_and_attach_phase": "Criar e associar à fase",
        "create_and_send": "Criar e enviar",
        "create_and_send_to_customer": "Criar e enviar ao cliente",
        "create_and_share": "Criar e partilhar com o cliente",
        "create_and_share_partners_only": "Criar e partilhar com parceiro(s)",
        "create_and_share_with_partners": "Criar e partilhar com o cliente e parceiro(s)",
        "next": "Seguinte",
        "only_create": "Apenas criar",
        "openFullPage": "Abrir em página inteira",
        "save": "Guardar",
        "saveChanges": "Guardar alterações",
        "save_as_draft": "Guardar como rascunho",
        "search": "Pesquisar...",
        "send": "Enviar",
        "send_and_create_another": "Enviar e criar outro",
        "send_to_customer": "Enviar ao cliente",
        "share_with_customer": "Partilhar com o cliente",
        "submit": "Enviar",
        "submit_and_create_another": "Enviar e criar outro"
      },
      "back": "Etapa anterior",
      "labels": {
        "columns": "Colunas",
        "from": "De",
        "no_results": "Sem resultados",
        "optional": "(opcional)",
        "to": "Até"
      },
      "notifications": {
        "textHasBeenCopied": "O texto foi copiado"
      },
      "password": "Palavra-passe",
      "send_moment": {
        "attach_failed": "Criado, mas não associado à fase. Associe-o novamente no fluxo de trabalho.",
        "concept_description": "Ninguém vê nada. Pode enviar mais tarde ou associar ainda a uma fase.",
        "concept_title": "Guardar como rascunho",
        "item_decision": "esta decisão",
        "item_survey": "este inquérito",
        "item_todo": "esta tarefa",
        "now_description_decision": "Os clientes das unidades selecionadas recebem a decisão de imediato, com uma notificação.",
        "now_description_survey": "Os clientes das unidades selecionadas recebem o inquérito de imediato, com uma notificação.",
        "now_description_todo": "Os responsáveis das unidades selecionadas recebem a tarefa de imediato, com uma notificação.",
        "now_title": "Enviar agora",
        "phase_description": "É enviado automaticamente para cada unidade assim que essa unidade chega à fase.",
        "phase_label": "Fase",
        "phase_title": "Associar a uma fase",
        "summary_concept": "Ainda nada enviado",
        "summary_phase": "É enviado quando uma unidade chega à fase",
        "title": "Quando é que o cliente vê {item}?",
        "workflow_help": "O que é um fluxo de trabalho?",
        "workflow_help_more": "Saber mais",
        "workflow_help_text": "Um fluxo de trabalho são as fases por que passa cada unidade. Se associar algo a uma fase, o cliente vê-o automaticamente assim que a sua unidade chega a essa fase."
      },
      "shortcuts": {
        "save_mac": "⌘ + Enter para guardar",
        "save_windows": "Ctrl + Enter para guardar",
        "send_mac": "⌘ + Enter para enviar",
        "send_windows": "Ctrl + Enter para enviar"
      },
      "steps": "Passo {count} de {total}",
      "writeEmployeeNameReject": "Escreva <i><b>{employeeName}</b></i> para continuar."
    }
  }
}
